import { apiClient } from "../../services/api";
import Vue from 'vue'

const state = () => ({
  colaboracoes_moderadas: {},
  pageModerada: 1,
  tarjaParams: null,
  colunas_ativas: null,
  colunas: null,
});

const getters = {
  colaboracoes_moderadas: state => {
    return state.colaboracoes_moderadas;
  },
  getterTarjaParams: state => {
    return state.tarjaParams;
  },
  getterColunas: state => {
    return state.colunas
  },
  getterColunasAtivas: state => {
    return state.colunas_ativas
  },
  getterPageModerada: state => {
    return state.pageModerada;
  }

};

const actions = {
  async getColaboracoesModeradas({ commit }, payload) {
    let { page, size, cod_producao, num_coluna_telao, filtro_texto_moderada } = payload;
    try {
      if (filtro_texto_moderada === undefined) {
        if (num_coluna_telao === 1) {
          filtro_texto_moderada = localStorage.getItem("@socialcam/filtro_texto_moderada") || ""
        } else if (num_coluna_telao === 2) {
          filtro_texto_moderada = localStorage.getItem("@socialcam/filtro_texto_moderada_2") || "";
        } else if (num_coluna_telao === 3) {
          filtro_texto_moderada = localStorage.getItem("@socialcam/filtro_texto_moderada_3") || "";
        }
      }

      const response = await apiClient.get(
        `/getColaboracaoModerada/${cod_producao}?page=${page}&size=${size}&num_coluna_telao=${num_coluna_telao}&filtro_texto=${filtro_texto_moderada}`
      );
      if (response.status === 200) {


        commit("setColaboracoesModeradas", { data: response.data.colaboracoes_moderadas, key: num_coluna_telao })

      }
    } catch (error) {
      console.error(error)
    }
  },
  assignTarjaParams({ commit }, payload) {
    commit('setTarjaParams', payload);
  },
  setPageModerada({ commit }, value) {
    commit('setPageModerada', value)
  },
  incrementTotalItems({ commit }, payload) {
    const { para_num_coluna_telao } = payload

    commit('incrementTotalItems', { para_num_coluna_telao, value: 1 })

  },
  async getColunas({ commit }, payload) {
    try {
      const { cod_producao, flg_ativo } = payload

      const response = await apiClient.get(`/listarColunasPorProducao/${cod_producao}?flg_ativo=${flg_ativo}`)

      if (response.status === 200) {
        if (flg_ativo) {
          commit('setColunasAtivas', response.data.colunas)
        } else {
          commit("setColunas", response.data.colunas)
        }

        return response.data.colunas

      }
    } catch (error) {
      console.error(error)
      this.$toast.error(error.response.data.msg)
    }


  }
};

const mutations = {
  setPageModerada(state, value) {
    state.pageModerada = value;
  },
  setColaboracoesModeradas(state, payload) {
    Vue.set(state.colaboracoes_moderadas, payload.key, payload.data)
  },
  setTarjaParams(state, payload) {
    state.tarjaParams = payload;
  },
  incrementTotalItems(state, payload) {
    state.colaboracoes_moderadas[payload.para_num_coluna_telao].totalItems += payload.value
  },
  setColunas(state, payload) {
    state.colunas = payload
  },
  setColunasAtivas(state, payload) {
    state.colunas_ativas = payload
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
